import * as Progress from "@radix-ui/react-progress";
import { useEffect, useState } from "react";

const PROGRESS_MAX = 100;

type ProgressBarProps = { progress: number };

function ProgressBar({ progress }: ProgressBarProps) {
  const [currentProgress, setCurrentProgress] = useState(0);

  useEffect(() => {
    const timer = setTimeout(
      () => setCurrentProgress(Math.min(PROGRESS_MAX, progress)),
      150
    );
    return () => clearTimeout(timer);
  }, [progress]);

  return (
    <Progress.Root
      value={currentProgress}
      className="h-2xs bg-positive-xx-light relative w-full overflow-hidden rounded-xl"
      style={{
        // Fix overflow clipping in Safari
        // https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0
        transform: "translateZ(0)",
      }}
    >
      <Progress.Indicator
        className="ease-[cubic-bezier(0.65, 0, 0.35, 1)] bg-positive size-full rounded-r-xl transition-transform duration-[660ms]"
        style={{ transform: `translateX(-${100 - currentProgress}%)` }}
      />
    </Progress.Root>
  );
}

export default ProgressBar;
